'use client';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

/**
 * TableHead component, used to display the header of a table. Renders a native HTML thead element.
 *
 * @example
 * <TableHead>
 *   <TableRow>
 *     <TableHeaderCell>Name</TableHeaderCell>
 *     <TableHeaderCell>Age</TableHeaderCell>
 *   </TableRow>
 * </TableHead>
 */
const TableHead = forwardRef(function TableHead(rest, ref) {
    return jsx("thead", { ref: ref, ...rest });
});

export { TableHead };
